// src/wp-scripts/music/utils/analytics.js

/**
 * Dispatches a custom event to Google Analytics.
 * @param {string} eventName - Name of the action (e.g., 'track_listen')
 * @param {Object} [params={}] - Key/value pairs of metadata
 */
export const trackEvent = (eventName, params = {}) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
    } else if (process.env.NODE_ENV === 'development') {
        // Keeps your terminal/console clean but lets you verify things are working locally
        console.log(`[GA4 Dev Log] Event: ${eventName}`, params);
    }
};